export default{
    msg:'',
    editar:{},
    lista:'',
    pesquisa:'',
    evento:''
}